import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@ngneat/transloco';
import { UiTooltipModule } from '../ui-tooltip/ui-tooltip.module';
import { UiVideoplayerModule } from '../ui-videoplayer/ui-videoplayer.module';
import { UiControlQuestionEditComponent } from './ui-control-question-edit.component';

@NgModule({
  declarations: [UiControlQuestionEditComponent],
  exports: [UiControlQuestionEditComponent],
  imports: [CommonModule, TranslocoModule, UiTooltipModule, UiVideoplayerModule],
})
export class UiControlQuestionEditModule {}
